'use strict';

const Event = require('./../lib/events');

class ShareCopyLink {

    constructor() {

        Event.on('click', '[data-copy-link]', (event) => {
            event.preventDefault();

            const trigger = event.currentTarget;
            const url = trigger.dataset.copyLink;

            navigator.clipboard.writeText(url).then(() => {
                trigger.classList.add('copied');

                setTimeout(() => {
                    trigger.classList.remove('copied');
                }, 2000);
            });

        });

    }

}

module.exports = ShareCopyLink;
